import React from "react";
import PropTypes from "prop-types";
import CompactMetricCard from "src/components/InsightsPage/Cards/CompactMetricCard";

const ManagerToICRatioMetric = ({
  metric,
  orgMetric,
  loading,
  targetChanged,
}) => {
  return (
    <CompactMetricCard
      icon={["far", "users"]}
      title="Manager to IC Ratio"
      current={metric.current}
      currentFormatted={metric.currentFormatted}
      target={metric.target}
      targetFormatted={metric.targetFormatted}
      deltaFormatted={metric.deltaFormatted}
      ragStatus={metric.ragStatus}
      loading={loading}
      targetChanged={targetChanged}
      orgManagerToICRatio={orgMetric}
    />
  );
};

ManagerToICRatioMetric.propTypes = {
  metric: PropTypes.shape({
    current: PropTypes.number,
    currentFormatted: PropTypes.string,
    target: PropTypes.number,
    targetFormatted: PropTypes.string,
    deltaFormatted: PropTypes.string,
    ragStatus: PropTypes.string,
  }).isRequired,
  orgMetric: PropTypes.shape({
    currentFormatted: PropTypes.string,
  }),
  loading: PropTypes.bool,
  targetChanged: PropTypes.bool,
};

export default ManagerToICRatioMetric;
